import type { Feed } from '@knocklabs/client'
import { invariant } from '@seen/core/invariant'
import { useContext } from 'react'
import { KnockDoneFeedContext } from '#src/contexts/KnockFeedClientContext.tsx'

export function useKnockDoneFeedClient(): Feed {
  const knockDoneFeedClient = useContext(KnockDoneFeedContext)
  invariant(knockDoneFeedClient, 'KnockDoneFeedContext not found')
  return knockDoneFeedClient
}
